
<template>
  <div class="device-params space-y-4">
    <template v-if="deviceType === 'event'">
      <DeviceAlertParams v-model="val"/>
    </template>
    <template v-else>
      <div class="text-muted-foreground">Please select a device type.</div>
    </template>
  </div>
</template>

<script>
import DeviceAlertParams from './DeviceAlertParams.vue';

export default {
  name: 'DeviceParams',
  components: {
    DeviceAlertParams
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    deviceType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      val: this.value ? { ...this.value } : {}
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.val = newVal
        }
      },
      deep: true
    },
    val: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  }
}
</script>
